import React, {Component} from 'react';
import MediaQuery from 'react-responsive';

import { Container, Dropdown, Icon, Segment, Menu, Header, Dimmer, Loader } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.css';
import './Info.css';
import SiteInfo from '../data/info';
import SiteInfoComponent from '../components/SiteInfoComponent';
import SiteMap from '../components/SiteMap';

class Info extends Component {
  state = { activeItem: 'vsat', site: null }
  constructor(props) {
    super(props);
    this.siteInfo = new SiteInfo();
  }
  componentWillMount() {
    var initialView = this.props.params.subView ? this.props.params.subView : 'vsat';
    this.setState({activeItem: initialView, site: null });
  }
  componentDidMount() {
    var self = this;
    this.siteInfo.fetch(this.props.params.siteId).then(function(res) {
      const data = res.data;
      console.log(data);
      self.setState({site: data});
    });
  }

  handleTabClick = (e, { name }) => {
    this.setState({ activeItem: name });
    this.props.router.push('/site/' + encodeURIComponent(this.props.params.siteId) + '/' + name );
  }

  render() {
    if (this.state.site === null) {
      return (
          <Dimmer active>
            <Loader size='huge'>Loading…</Loader>
          </Dimmer>
      );
    } else {
      const { activeItem } = this.state;
      var body, header = <Header as="h1">{this.state.site.info.modem_name}</Header>;
      if (activeItem === 'vsat') {
        body = (
          <div>
            <Header as="h2">VSAT</Header>
            <SiteInfoComponent info={this.state.site.info}/>
          </div>
        );
      } else if (activeItem === 'traffic') {
        body = (
          <div>
            <Header as="h2">Traffic</Header>
            <p>Traffic be here</p>
          </div>
        );
      } else if (activeItem === 'satstat') {
        body = <p>Satstat be here</p>;
      } else if (activeItem === 'map') {
        body = <Container fluid><SiteMap lat={this.state.site.location.dlat} lng={this.state.site.location.dlng} footprints={this.state.site.location.footprints}/></Container>;
      }

      
      var menuItems = [
        {
          key: 'vsat',
          name: 'vsat',
          content: "VSAT",
          icon: 'list',
          onClick: this.handleTabClick,
          active: activeItem === 'vsat',
        },
        {
          key: 'traffic',
          name: 'traffic',
          content: 'Traffic',
          icon: 'signal',
          onClick: this.handleTabClick,
          active: activeItem === 'traffic',
        },
        {
          key: 'satstat',
          name: 'satstat',
          content:'Sat-Stat',
          icon: 'wifi',
          onClick: this.handleTabClick,
          active: activeItem === 'satstat',
        },
        {
          key: 'map',
          name: 'map',
          content: 'Map',
          icon: 'map',
          onClick: this.handleTabClick,
          active: activeItem === 'map'
        }
      ];

      var selectedItem = null;
      for (let obj of menuItems) {
        if (obj.active) {
          selectedItem = obj;
          break;
        }
      }

      const trigger = <span><Icon name={selectedItem.icon} />{selectedItem.content}</span>;

      // FIXME: the ui currently sucks on mobile since the width is constained
      //        this should be changed into an adaptive layout. Depending on device size.
      //
      // FIXME: redraw on size/orientation change so the correct UI is being selected
      return (
        <div>
          {header}
          <MediaQuery minDeviceWidth={720} orientation="landscape">
            <Menu items={menuItems} attached='top'/>
            <Segment attached='bottom'>
              {body}
            </Segment>
          </MediaQuery>
          <MediaQuery maxDeviceWidth={720}>
            <Dropdown trigger={trigger} button fluid options={menuItems}/>
            <Segment>
              {body}
            </Segment>
          </MediaQuery>
          {this.props.children}
        </div>
      );
          //<p>DNSBL: <ul>{this.state.info.dnsbl.result.map(result => <li>{result}</li>)}</ul></p>
    }
  }
}



export default Info;
//export default withStyles(s)(Info);



// WEBPACK FOOTER //
// ./src/views/Info.js